import React, { FC, useMemo, useRef, useState } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
  Summary,
  TotalItem,
} from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppCard, AppLayoutTop } from '../../../../../components/appComponents';
import $createStore from '../../../../../utils/create-store-instance';
import { HeaderForm } from './components';
import { onExporting } from './utils';

//import { CreateEditModal, DeleteModal } from "./components";

const NomenclatureCarrier: FC = () => {
  const refGrid = useRef<DataGrid | null>(null);

  const [dateBegin, setDateBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment(new Date()).format('YYYY-MM-DD'));

  const salaryDataStore: any = useMemo(() => {
    let params = new URLSearchParams({
      dateBegin,
      dateEnd,
    }).toString();

    return $createStore(`/v1/ComingNomenclature/carrierReport?${params}`, 'date');
  }, [dateBegin, dateEnd]);

  const defaultFilter = ['parentId', '=', null];

  const factoryStore = $createStore('/v1/factory', 'id', { defaultFilter });

  /* const openEmloyeeInfoHandler = (id: number) => {

        window.open(`/salary-drivers/${id}?${params}`, "_blank");
}; */

  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');

  const onExportingHandler = (e: any) => {
    onExporting(e, `${dateBeginText} - ${dateEndText}`);
  };

  return (
    <div className="container-dev">
      <AppLayoutTop title="Сверка по карьерам">
        <HeaderForm
          dateBegin={dateBegin}
          dateEnd={dateEnd}
          onChangeDateBegin={setDateBegin}
          onChangeDateEnd={setDateEnd}
        />
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={salaryDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          //onRowDblClick={(e) => openEmloyeeInfoHandler(e.data.id)}
          onExporting={onExportingHandler}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          remoteOperations
        >
          <StateStoring enabled={true} type="localStorage" storageKey="comingNomenclatureCarrierReport" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={130} />
          <Column dataField="nomenclature" caption="Материал" />
          <Column dataField="contractor" caption="Контрагент" />
          <Column dataField="nomenclatureAnotation" caption="Материал по документам" />
          <Column dataField="carrier" caption="Карьер" />
          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="trailer" caption="Прицеп" />
          <Column dataField="driver" caption="Водитель" />
          <Column dataField="quantity" caption="Объем" width={220} />
          <Column dataField="unitName" caption="Ед. изм." />
          <Column dataField="factoryId" caption="Площадка">
            <Lookup dataSource={factoryStore} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="comment" caption="Комментарий" />
          <Column dataField="transportComment" caption="Комментарий транспорта" />
          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default NomenclatureCarrier;
